import * as z from 'zod';

export const PaginationSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  pageCount: z.number().optional(),
  total: z.number().optional(),
});

export const ApiMetaSchema = z.object({
  pagination: PaginationSchema.optional(),
});

export const ApiResponseSchema = <TSchema extends z.ZodTypeAny>(dataSchema: TSchema) => {
  return z.object({
    data: dataSchema,
    meta: ApiMetaSchema,
  });
};
